import { render, staticRenderFns } from "./ModalCostosPrograma.vue?vue&type=template&id=52242a01"
import script from "./ModalCostosPrograma.vue?vue&type=script&lang=js"
export * from "./ModalCostosPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports